(function () {
  var HYPOTHESIS_ID = '019dd716-9e69-76b9-a627-d653f81a6762';
  var SELECTOR = '[data-shoplift-hypothesis="' + HYPOTHESIS_ID + '"]';

  function applyTreatment() {
    document.querySelectorAll(SELECTOR).forEach(function (wrapper) {
      wrapper.classList.add('is-treatment');
      var control = wrapper.querySelector('[data-variant="control"]');
      var treatment = wrapper.querySelector('[data-variant="treatment"]');
      if (control) control.setAttribute('aria-hidden', 'true');
      if (treatment) treatment.removeAttribute('aria-hidden');
    });
  }

  function check(attempts) {
    if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
      window.shoplift.isHypothesisActive(HYPOTHESIS_ID).then(function (isVariant) {
        if (isVariant) applyTreatment();
      });
      return;
    }
    if (attempts < 50) setTimeout(function () { check(attempts + 1); }, 100);
  }

  if (document.querySelector(SELECTOR)) check(0);
})();